/* eslint-disable filenames/match-regex */
import DateUtils from 'utils/DateUtils';
import Format from 'utils/Format';
import { formatDate } from './printService';

export function renderHTMLBill(data) {
    const newDate = DateUtils.formatDayAndTimePicker(new Date()).split('/')[1];
    console.log('data', data);
    const _user = localStorage.getItem('Apec_Account');
    const user = _user && JSON.parse(_user).username;
    const date = newDate.split(' ');
    const renderColumn = () => {
        let _column = '';
        const list = data?.itemsends && data.itemsends?.filter(e =>e?.ipaddress === data?.ipaddress);
        for(let i=0; i < list.length; i++) {
            _column += `<tr style="vertical-align:top;">
                <td style="width:0px;height:19px;"></td>
                <td class="csD5125DAB" colspan="1" style="width:12px;height:12px;line-height:10px;text-align:center;vertical-align:middle;"><nobr>${i + 1}</nobr></td>
                <td class="csC76BB281" colspan="6" style="width:68px;height:12px;line-height:10px;text-align:left;vertical-align:middle; word-wrap: break-word; white-space: normal;">
                ${list[i]?.iname}
            </td>
                <td class="csD5125DAB" colspan="2" style="width:20px;height:12px;line-height:10px;text-align:center;vertical-align:middle;"><nobr>${list[i]?.unit}</nobr></td>
                <td class="csD5125DAB" colspan="3" style="width:22px;height:12px;line-height:10px;text-align:center;vertical-align:middle;"><nobr>${list[i]?.quanitity}</nobr></td>
                <td class="csD5125DAB" colspan="5" style="width:41px;height:12px;line-height:10px;text-align:center;vertical-align:middle;"><nobr>${list[i]?.price}</nobr></td>
                <td class="csD5125DAB" colspan="5" style="width:46px;height:12px;line-height:10px;text-align:right;vertical-align:middle;"><nobr>${Number(list[i]?.price  || 0)* Number(list[i]?.quanitity  || 0)}</nobr></td>
            </tr>`;
        }
        return _column;
    };
    return `
    <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<!-- saved from url=(0016)http://localhost -->
<html>
<head>
	<title>Document</title>
	<meta HTTP-EQUIV="Content-Type" CONTENT="text/html; charset=utf-8"/>
	<style type="text/css">
		.cs4FADFF8F {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right:#FFFFFF 2px solid;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; }
		.cs4B1904F1 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right:transparent 1px solid;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; }
		.csC76BB281 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom:#000000 1px dashed;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-top:3px;padding-left:3px;padding-bottom:3px;}
		.csD5125DAB {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom:#000000 1px dashed;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-top:3px;padding-left:3px;padding-right:3px;padding-bottom:3px;}
		.cs8EA18762 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:normal; padding-left:2px;}
		.csFEAFFC4D {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:normal; padding-left:2px;padding-right:2px;}
		.cs8F0C1850 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:italic; padding-left:2px;padding-right:2px;}
		.cs5F7AA6EF {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:normal; padding-left:2px;padding-right:2px;}
		.cs6FC5B17 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:13px; font-weight:bold; font-style:normal; padding-left:2px;padding-right:2px;}
		.csA8DCAC4A {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:13px; font-weight:normal; font-style:normal; }
		.cs636938EA {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:italic; padding-left:2px;}
		.csA676D0BF {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; }
		.csB8BEB134 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; padding-left:1px;}
		.csADEC2D6F {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; padding-left:2px;}
		.csB839DCA6 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-left:3px;}
		.cs27313B43 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-left:4px;}
		.cs9691FC92 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-left:7px;}
		.cs693942EE {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-top:3px;padding-left:3px;padding-bottom:3px;}
		.csDA17CD4C {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-top:3px;padding-left:3px;padding-right:3px;padding-bottom:3px;}
		.csAC6A4475 {height:0px;width:0px;overflow:hidden;font-size:0px;line-height:0px;}
		.text {color:#000000;margin-bottom: 0px; text-align: center;background-color:transparent;border-left-style: none; font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; }
        .signature {
            display: flex;
            gap: 80px;
        }
        .signature div {
            width: 50%;
            text-align: center;
        }
        .bt {
            display: flex;
            flex-direction: column;
            width: 100%;
        }
	</style>
</head>
<body leftMargin=10 topMargin=10 rightMargin=10 bottomMargin=10 style="background-color:#FFFFFF; overflow-y: auto; width: 330px; margin-top: 20px"> 
<table cellpadding="0" cellspacing="0" border="0" style="border-width:0px;empty-cells:show;width:242px;height:410px;position:relative;">
	<tr>
		<td style="width:0px;height:0px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:8px;"></td>
		<td style="height:0px;width:9px;"></td>
		<td style="height:0px;width:6px;"></td>
		<td style="height:0px;width:7px;"></td>
		<td style="height:0px;width:10px;"></td>
		<td style="height:0px;width:4px;"></td>
		<td style="height:0px;width:5px;"></td>
		<td style="height:0px;width:23px;"></td>
		<td style="height:0px;width:16px;"></td>
		<td style="height:0px;width:15px;"></td>
		<td style="height:0px;width:11px;"></td>
		<td style="height:0px;width:10px;"></td>
		<td style="height:0px;width:4px;"></td>
		<td style="height:0px;width:14px;"></td>
		<td style="height:0px;width:6px;"></td>
		<td style="height:0px;width:6px;"></td>
		<td style="height:0px;width:5px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:4px;"></td>
		<td style="height:0px;width:3px;"></td>
		<td style="height:0px;width:22px;"></td>
		<td style="height:0px;width:16px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:30px;"></td>
		<td style="height:0px;width:1px;"></td>
		<td style="height:0px;width:4px;"></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:12px;"></td>
		<td></td>
		<td></td>
		<td class="csA676D0BF" colspan="24" style="width:229px;height:12px;line-height:10px;text-align:left;vertical-align:top;"><nobr>${data?.hotelDetail?.hotelName || ''}</nobr></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:13px;"></td>
		<td></td>
		<td></td>
		<td class="csA676D0BF" colspan="24" style="width:36px;height:13px;line-height:10px;text-align:left;vertical-align:top;"><nobr>Website: ${data?.hotelDetail?.website || ''}</nobr></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:13px;"></td>
		<td></td>
		<td></td>
		<td class="csA676D0BF" colspan="24" style="width:22px;height:13px;line-height:10px;text-align:left;vertical-align:top;"><nobr>Add: ${data?.hotelDetail?.address || ''}</nobr></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:10px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:13px;"></td>
		<td></td>
		<td></td>
		<td class="csA676D0BF" colspan="10" style="width:41px;height:13px;line-height:10px;text-align:left;vertical-align:top;"><nobr>Tax&nbsp;code: ${data?.hotelDetail?.taxCode || ''}</nobr></td>
		<td></td>
		<td class="csA676D0BF" colspan="2" style="width:36px;height:13px;line-height:10px;text-align:left;vertical-align:top;"><nobr>Hotline:</nobr></td>
		<td class="csADEC2D6F" colspan="8" style="width:76px;height:13px;line-height:10px;text-align:left;vertical-align:top;"><nobr>${data?.hotelDetail?.phone || ''}</nobr></td>
		<td></td>
	</tr>
    <tr style="vertical-align:top;">
    <td style="width:0px;height:10px;"></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
</tr>
    <tr style="vertical-align:top;">
    <td colspan="27" style="height:1px; border-bottom: 1px dashed black;"></td>
</tr>
<tr style="vertical-align:top;">
<td style="width:0px;height:10px;"></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:22px;"></td>
		<td class="cs6FC5B17" colspan="27" style="width:238px;height:22px;line-height:15px;text-align:center;vertical-align:middle;"><nobr>H&#211;A&nbsp;ĐƠN&nbsp;B&#193;N&nbsp;H&#192;NG</nobr></td>
	</tr>
    
	<tr style="vertical-align:top;">
		<td style="width:0px;height:10px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>

    <tr style="vertical-align:top;">
		<td style="width:0px;height:10px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:13px;"></td>
		<td class="csADEC2D6F" colspan="1" style="width:29px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>Ng&#224;y:</nobr></td>
		<td class="cs27313B43" colspan="11" style="width:87px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>${data.orderTime}</nobr></td>
		<td class="csADEC2D6F" colspan="1" style="width:51px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>Địa&nbsp;điểm:</nobr></td>
		<td class="csB839DCA6" colspan="11" style="width:84px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>${data.location}</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:9px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:13px;"></td>
		<td class="csADEC2D6F" colspan="1" style="width:39px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>Order:</nobr></td>
		<td class="cs9691FC92" colspan="11" style="width:84px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>${data.orderNo}</nobr></td>
		<td class="csADEC2D6F" colspan="1" style="width:48px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>Ng&#224;y&nbsp;in:</nobr></td>
		<td class="csB839DCA6" colspan="11" rowspan="2" style="width:90px;height:23px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>${formatDate(data?.printDate || '')}</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:2px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:24px;"></td>
		<td class="cs4FADFF8F" colspan="1" style="width:16px;height:24px;line-height:9px;text-align:center;vertical-align:middle;"><nobr>STT</nobr></td>
		<td class="cs4FADFF8F" colspan="6" style="width:69px;height:24px;line-height:9px;text-align:center;vertical-align:middle;"><nobr>Mặt&nbsp;h&#224;ng</nobr></td>
		<td class="cs4FADFF8F" colspan="2" style="width:24px;height:24px;line-height:9px;text-align:center;vertical-align:middle;"><nobr>ĐVT</nobr></td>
		<td class="cs4FADFF8F" colspan="3" style="width:26px;height:24px;line-height:9px;text-align:center;vertical-align:middle;"><nobr>SL</nobr></td>
		<td class="cs4FADFF8F" colspan="5" style="width:45px;height:24px;line-height:9px;text-align:center;vertical-align:middle;"><nobr>Đơn&nbsp;gi&#225;</nobr></td>
		<td class="cs4B1904F1" colspan="5" style="width:51px;height:24px;line-height:9px;text-align:right;vertical-align:middle;"><nobr>Th&#224;nh&nbsp;tiền</nobr></td>
	</tr>
    ${renderColumn()}
	<tr style="vertical-align:top;">
		<td style="width:0px;height:10px;"></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
		<td></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:17px;"></td>
		<td class="cs8EA18762" colspan="9" style="width:71px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Tổng tiền:</nobr></td>
		<td class="csFEAFFC4D" colspan="12" style="width:129px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.totalAmount)} VND</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td style="width:0px;height:16px;"></td>
		<td class="cs8EA18762" colspan="9" style="width:48px;height:16px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Giảm&nbsp;gi&#225;&nbsp${data?.isDiscountPer === 'Y' ? `(${data?.discount}%)` : ''}:</nobr></td>
		<td class="csFEAFFC4D" colspan="12" style="width:87px;height:16px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.billDiscount)} VND</nobr></td>
	</tr>
    <tr style="vertical-align:top;">
    <td class="cs8EA18762" colspan="10" style="width:102px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Thành tiền trước thuế:</nobr></td>
    <td class="csFEAFFC4D" colspan="12" style="width:99px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(Number(data.subTotal) )} VND</nobr></td>
</tr>
	<tr style="vertical-align:top;">
		<td class="cs8EA18762" colspan="10" style="width:102px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Thuế&nbsp;&amp;&nbsp;ph&#237;&nbsp;dịch&nbsp;vụ:</nobr></td>
		<td class="csFEAFFC4D" colspan="12" style="width:99px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(Number(data.tax) + Number(data.serviceCharge))} VND</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td class="cs8EA18762" colspan="10" style="width:127px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Tổng&nbsp;tiền&nbsp;phải&nbsp;thanh&nbsp;to&#225;n:</nobr></td>
		<td class="csFEAFFC4D" colspan="12" style="width:74px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.total)} VND</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td class="cs8EA18762" colspan="10" style="width:87px;height:16px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Tiền&nbsp;kh&#225;ch&nbsp;trả:</nobr></td>
		<td class="csFEAFFC4D" colspan="12" style="width:113px;height:16px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.amountPaid)} VND</nobr></td>
	</tr>
	<tr style="vertical-align:top;">
		<td class="cs8EA18762" colspan="10" style="width:71px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Tiền&nbsp;trả&nbsp;lại:</nobr></td>
		<td class="csFEAFFC4D" colspan="12" style="width:129px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.dueBack)} VND</nobr></td>
	</tr>
    <tr style="vertical-align:top;">
		<td class="cs8EA18762" colspan="10" style="width:71px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Phuơng thức thanh toán:</nobr></td>
		<td class="csFEAFFC4D" colspan="12" style="width:129px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${data.paymentMethod || ''}</nobr></td>
	</tr>
    <tr style="vertical-align:top;">
    <td colspan="27" style="height:1px; border-bottom: 1px dashed black;"></td>
</tr>
   </div>
</table>
<div class="signature">
   <p class="csFEAFFC4D" >Cashier signature</p>
    <p class="csFEAFFC4D" >Guest signature</p>
</div>
<p class="csFEAFFC4D"> &nbsp;&nbsp;&nbsp;${user}</p>
 <div class="bt">
<div class="signature" style="height:1px; border-bottom: 1px dashed black; margin-bottom: 4px"></div>
 <p class="text">(Giá đã bao gồm thuế GTGT và phí dịch vụ)</p>
 <p class="text"><em>Cảm ơn quý khách và hẹn gặp lại!</em></p>
 </div>
</body>
</html>
    `;
}
